// Module
var code = "<div class=\"cdc-container create-dashboard-step\"> <h2>Create Dashboard</h2> <div id=\"description\" style=\"display:none\"></div> <div id=\"source-form-container\" class=\"z-depth-1\"></div> </div>";
// Exports
export default code;